import React from "react"
import { TextField } from "@material-ui/core";
import styled from "styled-components";
import windowSize from "../../../constants/WindowSize";
import { globalColors } from "../../../../_metronic/_assets/sass/custom/globalColors";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100%;
  padding: 20px 0 0 0;
  background-size: cover;
  background-color: ${globalColors.colorWhite};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  margin: ${({ width }) => (width >= windowSize.SM ? "40px auto" : 0)};
  max-width: 450px;
`;

export const ContainerWithIcon = styled.div`
  width: 100%;
  padding: ${({ width }) => (width >= windowSize.SM ? `60px 60px` : `0 20px`)};
  border: ${({ width }) => (width >= windowSize.SM ? `1px solid #00A4B2` : 0)};
`;

export const ContainerInputs = styled.div`
  > h1 {
    color: ${globalColors.primaryColor2};
    margin-bottom: 20px;
    font-family: "Open Sans";
    font-weight: 600;
    text-align: center;
  }

  > h3 {
    color: ${globalColors.primaryColor2};
    text-align: center;
    margin-bottom: 20px;
    font-family: "Open Sans";
    font-weight: 600;
  }

  .subtitle {
    text-align: center;
    color: ${globalColors.primaryColor2};
    font-size: 16px;
    font-family: "Open Sans";
    font-weight: 500;

    margin-bottom: 15px;

    &.success {
      margin-bottom: 24px;
    }
  }

  form {
    display: flex;
    flex-direction: column;

    & > .MuiFormControl-root.MuiTextField-root:first-child {
      margin: 5px 0 15px;
    }
  }

  a {
    display: flex;
    flex: 1;
    padding: 15px 0;
    align-items: center;
    justify-content: center;
    background-color: ${globalColors.colorWhite};
    border: none;
    color: ${globalColors.primaryColor2};
    border-radius: 12px;
    font-size: 18px;
    font-weight: 600;
    font-family: "Open Sans";

    :hover {
      transition: opacity 0.4s;
      opacity: 0.8;
      text-decoration: underline !important;
    }
  }
`;

export const ContainerReCaptcha = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0 20px;
`;

export const StyledInput = styled(({ ...props }) => (
  <TextField InputLabelProps={{ shrink: true }} {...props} />
))`
  margin-bottom: 5px;

  .MuiInputLabel-shrink {
    font-size: 18px;
    color: ${globalColors.textColor2};
  }

  .MuiOutlinedInput-notchedOutline {
    border: 0.5px solid ${globalColors.backgroundColor2};
  }

  input {
    font-size: 18px;
    padding: 10px 15px;
  }
`;
